import React from 'react';
import { Button } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import AuthLayout from '../layouts/AuthLayout';
import Router from 'next/router';

export function Error500() {
  const [isMobile, setMobile] = React.useState(null);

  React.useEffect(() => {
    const isMobile = document.documentElement.clientWidth < 768;
    if (isMobile) {
      setMobile(isMobile);
    }
  }, []);
  return (
    <AuthLayout text="Internal Server Error">
      <p id="layout__p__eror_layout_22" className="error-code-text">
        500
      </p>
      <p id="layout__p__eror_layout_23" className="primary-error-massage">
        {' '}
        Oops, Something went wrong.
      </p>
      <p id="layout__p__eror_layout_24" className={isMobile ? 'error-msg-mobile' : 'error-msg '}>
        The server encountered an internal error or misconfiguration and was unable to complete your request
      </p>

      <Button id="layout__button__eror_layout_0" className="main-btn" onClick={() => Router.reload()}>
        <span id="layout__buttontext__eror_layout_1">Try Again</span>{' '}
      </Button>

      <Button id="layout__button__eror_layout_3" className="back-btn" onClick={() => Router.push('/')}>
        <ArrowBackIosIcon fontSize="small" />
        <span id="layout__buttontext__eror_layout_4">Back to Previous Page</span>
      </Button>
    </AuthLayout>
  );
}

export function TypeError({ errorMessage = '' }) {
  return (
    <AuthLayout text="Internal Server Error">
      <p className="type-error-text">{errorMessage || 'Oops, Something went wrong.'}</p>
      <Button id="layout__button__eror_layout_5" className="main-btn" onClick={() => Router.reload()}>
        {' '}
        <span id="layout__buttontext__eror_layout_6">Reload </span>
      </Button>
      <Button id="layout__button__eror_layout_7" className="back-btn" onClick={() => Router.back()}>
        <ArrowBackIosIcon fontSize="small" />
        <span id="layout__buttontext__eror_layout_8">Back to Previous Page</span>
      </Button>
    </AuthLayout>
  );
}

export function PageNotFound() {
  return (
    <AuthLayout text="Page not found">
      <p className="error-code-text">404</p>
      <p className="error-msg">This page could not be found.</p>

      <Button id="layout__button__eror_layout_9" className="main-btn" onClick={() => Router.push('/')}>
        <span id="layout__buttontext__eror_layout_10">GO TO HOMEPAGE </span>
      </Button>
      <Button id="layout__button__eror_layout_11" className="back-btn" onClick={() => Router.back()}>
        <ArrowBackIosIcon fontSize="small" />
        <span id="layout__buttontext__eror_layout_12">Back to Previous Page </span>
      </Button>
    </AuthLayout>
  );
}

export function AuthError({ error }) {
  console.log('error', error);
  // purposefully kept this log
  // component do not render sometimes
  return (
    <AuthLayout text="Authentication Failed">
      {error.errorCode === 'token_expired' ? (
        <>
          <p className="type-error-text">Sorry, you are not Assigned to this App</p>
          <p className="error-msg">{error.errorSummary}</p>
          <Button id="layout__button__eror_layout_13" className="main-btn" onClick={() => Router.push('/')}>
            <span id="layout__buttontext__eror_layout_14">GO TO HOMEPAGE</span>
          </Button>
        </>
      ) : error.errorCode === 'access_denied' ? (
        <>
          <p className="type-error-text">{error.errorMessage || 'Sorry, you are not Assigned to this App'} </p>
          {!error.errorMessage && <p className="error-msg">Please Contact your Administrator</p>}
          {!error.errorMessage && (
            <Button
              id="layout__button__eror_layout_15"
              className="main-btn"
              onClick={() => Router.push('/?manualLogin=true')}
            >
              <span id="layout__buttontext__eror_layout_16">GO TO HOMEPAGE </span>
            </Button>
          )}
          <Button
            id="layout__button__eror_layout_17"
            className={error.errorMessage ? 'main-btn' : 'back-btn'}
            onClick={() => (error.retryHandler ? error.retryHandler() : Router.push('/login?manualLogin=true'))}
          >
            <span id="layout__buttontext__eror_layout_18">{error.errorMessage ? 'LOGIN' : 'RETRY LOGIN'} </span>
          </Button>
        </>
      ) : error.errorCode === 'authentication-error' ? (
        <>
          <p className="type-error-text m-0">
            {error.errorMessage || 'Sorry, user account not found with this email'}{' '}
          </p>
          <p className="type-error-text mt-0 type-error-text-description">
            {'Please make sure you have entered the correct email address.'}{' '}
          </p>
          {!error.errorMessage && <p className="error-msg">Please Contact your Administrator</p>}
          <Button id="layout__button__eror_layout_13" className="main-btn" onClick={() => Router.push('/')}>
            <span id="layout__buttontext__eror_layout_14">GO TO HOMEPAGE</span>
          </Button>
          <Button
            id="layout__button__eror_layout_17"
            className={error.errorMessage ? 'main-btn' : 'back-btn'}
            onClick={() => (error.retryHandler ? error.retryHandler() : Router.push('/login?manualLogin=true'))}
          >
            <span id="layout__buttontext__eror_layout_18">{'RETRY LOGIN'} </span>
          </Button>
        </>
      ) : (
        <>
          <p className="type-error-text">Oops, Something went wrong.</p>
          <p className="error-msg">{error.errorSummary}</p>
          <Button
            id="layout__button__eror_layout_19"
            className="main-btn"
            onClick={() => Router.push('/?manualLogin=true')}
          >
            <span id="layout__buttontext__eror_layout_20">GO TO HOMEPAGE </span>
          </Button>
          <Button
            id="layout__button__eror_layout_21"
            className="back-btn"
            onClick={() => Router.push('/login?manualLogin=true')}
          >
            <span id="layout__buttontext__eror_layout_22">RETRY LOGIN </span>
          </Button>
        </>
      )}
    </AuthLayout>
  );
}
